import * as Sentry from "@sentry/vue";

const KEY = "__preload";
const MAX_RETRIES = 2;

// https://vite.dev/guide/build#load-error-handling
//
// idea based on:
// - https://github.com/vitejs/vite/issues/11804
// - https://www.vidbeo.com/blog/reload-nuxt-spa-on-missing-chunk-error/
// - https://paulau.dev/blog/handle-version-skew-after-new-deployment-with-vite-and-vue-router/
// - https://stackoverflow.com/questions/69300341/typeerror-failed-to-fetch-dynamically-imported-module-on-vue-vite-vanilla-set/78136284#78136284
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();

  const url = new URL(location.href);
  const tries = +(url.searchParams.get(KEY) ?? 0);

  // https://docs.sentry.io/platforms/javascript/usage/#capturing-messages
  Sentry.captureMessage("vite-chunk-reload", {
    level: "info",
    fingerprint: ["vite-chunk-reload"], // all reports roll into ONE issue
    tags: { tries, path: location.pathname },
  });

  // reload protection, prevent infinite reloads
  if (tries >= MAX_RETRIES) return;

  url.searchParams.set(KEY, String(tries + 1));
  location.replace(url.toString());
});
